import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { DossierService } from '@shared/services/cabinet/dossier.service';
import { NotificationService } from '../../ui/notification/notification.service';
import { dossierIdDeLaRoute } from '../page-arrivee';
import { urlAccueil } from '../chemins';

/** Message affiché quand le dossier n'a pas d'exercice comptable. */
const MSG_SANS_EXERCICE = "Ce module nécessite une date de début et de fin d’exercice.";

/**
 * Écran qui exige un exercice comptable (dates de début et de fin). Le dossier vérifié est celui de l'URL :
 * la garde passe avant le resolver, le dossier courant peut être l'ancien ou vide (arrivée depuis la liste des
 * dossiers : dossierId vaut 0), il ne sert que s'il s'agit déjà du dossier de l'URL.
 * Sans exercice : message d'erreur, puis accueil du dossier (même règle que les autres gardes) ; lecture du dossier
 * en échec : accueil du dossier.
 */
export const hasExerciceComptableGuard: CanActivateFn = (route) => {
  const dossierService = inject(DossierService);
  const toast = inject(NotificationService);
  const router = inject(Router);
  const id = dossierIdDeLaRoute(route) || dossierService.dossierId;
  if (dossierService.currentDossier.id === id && dossierService.hasExerciceComptable) {
    return true;
  }
  const accueil = router.parseUrl(urlAccueil(id));
  const cabinetId = dossierService.cabinetId;
  return dossierService.get(id, cabinetId || undefined).pipe(
    map((dossier) => {
      if (!!dossier.dateDebutExercice && !!dossier.dateFinExercice) {
        return true;
      }
      toast.erreur(MSG_SANS_EXERCICE);
      return accueil;
    }),
    catchError(() => of(accueil)),
  );
};
